export const styles = {
  content: 'tw-space-y-6',
};
